import { NoticeAPI } from "@/api"
import { login, requestEmail, SetHeader, getNetworkType } from "@/api/access"
import store from "@/api/store"
import { HeaderWithoutMenu } from "../../mixins/header"
import ToggleBox from "../../mixins/togglebox"
import DialogManagerApply from "../../dialogs/dialogManagerApply.vue"
import DialogAgentApply from "../../dialogs/dialogAgentApply.vue"
import AppState from "@/plugins/appstate"
import ConfirmDialogs from "@/components/mixins/dialog/confirm.vue"

const FB_FUNC = m => {
  if (/^WEB_AUTH/.test(m)) m = "WEB_AUTH"
}

export default {
  name: "login-component",
  components: { HeaderWithoutMenu, ToggleBox, DialogManagerApply, DialogAgentApply, ConfirmDialogs },
  computed: {
    isMobile() {
      const mobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent) || /Mobi/i.test(window.navigator.userAgent)
      const isAndroid = /Android/i.test(window.navigator.userAgent)
      let isIpad = /Macintosh/i.test(window.navigator.userAgent) && window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 1
      if (mobile || isIpad) {
        let type = isAndroid ? "android" : "ios"
        if (/LinkMeMine/i.test(window.navigator.userAgent)) {
          type = "app"
        }
        return type
      }
      return false
    },
  },
  methods: {
    openDialogManagerApply() {
      window.open("/#/ko/popup/manager", "popup-manager", "width=800,height=900,scrollbars=no,resizable=no")
    },
    openDialogAgentApply() {
      window.open("/#/ko/popup/agent", "popup-agent", "width=800,height=900,scrollbars=no,resizable=no")
    },
    focusIn() {
      this.$refs.inpQrCode.focus()
    },
    checkValidQrCode(value, event) {
      let v = value.replace(/\D/g, "")
      this.optCode = v
    },
    noticePopupSkipChanged(value) {
      this.noticePopup.skip = value
    },
    noticePopupOpen(notice) {
      this.noticePopup.content = notice
      this.noticePopup.skipCheck = false
      this.noticePopup.show = true
    },
    noticePopupClose() {
      this.noticePopup.show = false
      if (this.noticePopup.skip) {
        store.set("notice_skip", this.noticePopup.content.pk)
      }
    },
    updatePopupSkipChanged(value) {
      this.updatePopup.skip = value
    },
    updatePopupClose() {
      this.updatePopup.show = false
      if (this.updatePopup.skip) {
        store.set("popup_skip", "update")
      }
    },
    loginTypeChanged(value) {
      this.loginType = value
      if (this.isMobile) {
        this.downloadButtonText = this.$t('login_page.download_android_remote_device')
      }
    },
    rememberChanged(value) {
      this.remember = value
      if (this.AppState.isApplication) {
        this.autoLoginStateHandler(value)
      }
    },
    changeMode(value) {
      this.saveViewMode = value
    },
    autoLoginStateHandler(value) {
      this.autologinReadableValue = value ? "YES" : "NO"
      const today = new Date()
      const expire = new Date()
      expire.setDate(today.getDate() + 7)
      store.set("lmm_autologin", value, expire.getTime())
      if (window.LMM_MOBILE_SEND) {
        window.LMM_MOBILE_SEND("WEB_CHECK:CHANGED:" + this.autologinReadableValue)
      }
    },
    hideSendEmail() {
      this.showSendEmail = false
    },
    hideOTP() {
      this.showOTP = false
    },
    sendEmail() {
      let params = {
        email: this.verifyEmail,
        key: this.respData.email,
        mgrid: this.respData.id,
        lang_code: this.$i18n.locale,
      }
      requestEmail(params).then(resp => {
        if (/success/i.test(resp.result)) {
          this.AppState.$emit("show-message-dialog", {
            title: "LinkMeMine",
            context: { path: "not_email_auth" },
          })
        } else {
          this.AppState.$emit("show-message-dialog", {
            title: "LinkMeMine",
            context: { path: "email_send_fail" },
          })
        }
      })
    },
    onSubmit(evt) {
      if (evt) evt.preventDefault()
      if (this.remember) store.set("remember", this.form.id)
      else store.remove("remember")

      if (this.saveViewMode) store.set("viewMode", this.modeSelected)
      else store.set("viewMode", "normal")
      const { isMobile, isApplication, os } = AppState
      let authData = {}

      if (!isMobile) {
        authData = {
          type: "1STEP",
          id: this.form.id,
          pw: this.form.passwd,
        }
      } else {
        authData = {
          type: "1STEP",
          id: this.form.id,
          pw: this.form.passwd,
          deviceId: this.form.deviceId,
          os: this.form.os,
          ip: this.form.ip,
          mode: "Mobile",
        }
      }
      authData.loginType = this.loginType

      login(authData, (err, resp) => {
        if (err === "loadingPage") {
          if (this.isMobile !== "app") {
            this.showImg = true
          }
          return
        }
        if (err === "popup-blocked") {
          this.popupBlock = true
          return
        } else if (err === "logout") {
          window.location.reload()
          return
        }
        if (err) {
          this.respData = err.objects
          const res = this.respData
          if (/fail/i.test(res.step1)) {
            let messageKey = ""
            if (res.cause) {
              for (let key in res.cause) {
                let limit = res.failure_limit
                let current = res.current_failure
                if (limit != 0 && limit == current) {
                  messageKey = "login_failure_limit"
                } else if (key === "pw_reject") {
                  this.$router.push({ name: "access-retypepassword", params: { userid: authData.id } })
                  messageKey = "password_change_limit"
                } else {
                  messageKey = "login_failed_cause_" + key
                }
              }
            } else {
              messageKey = "invalid_id_and_pw"
            }
            this.AppState.$emit("show-message-dialog", {
              title: "LinkMeMine",
              context: { path: messageKey },
              userId: this.form.id,
              selfUnlock: res.self_unlock,
            })
          } else if (/fail/i.test(res.step2)) {
            this.verifyEmail = res.email
            this.showSendEmail = true
          } else if (/fail/i.test(res.step3)) {
            this.showOTP = true
          }
          this.showImg = false
          return
        }
        // 로그인이 되면 다시 앱 쪽으로 호출한다. 따라서 id pw를 앱쪽으로 넘긴다. -> 비밀번호 부분은 필요 없기 때문에 제거
        // LMM_MOBILE_EXIST_AUTH는 자동로그인이고, 삼성생명 프로젝트에는 자동로그인 기능이 필요없으므로, 주석처리.
        if (this.AppState.isApplication) {
          window.LMM_MOBILE_SEND("WEB_AUTH:" + btoa(JSON.stringify({ userid: authData.id, userpw: authData.pw })) + ":" + resp.license.list[0].account_type)
          window.LMM_MOBILE_EXIST_AUTH = true
        }
        this.AppState.Info.dateFmt = resp.dateFmt
        // this.$router.push({ name: "deviceAll", params: { groupPk: "all" } })
        this.$router.push({ name: "device-root" })

        this.AppState.viewMode = this.modeSelected
        store.set("viewMode", this.modeSelected)
      })
    },
    otpLogin() {
      if (!this.respData.token) return
      SetHeader("token", this.respData.token)
      let authData = {
        type: "3STEP",
        code: this.optCode,
      }
      login(authData, (err, resp) => {
        if (err) {
          let res = err.objects
          if (res && res.cause && res.cause.detail === "otp_token_expired") {
            this.AppState.$emit("show-message-dialog", {
              title: "LinkMeMine",
              context: { path: "otp_token_expired" },
            })
            this.showOTP = false
          } else if (res && /fail/i.test(res.step3)) {
            let msgPath = "invalid_otp"
            if (res.failure_limit > 0 && res.failure_limit === res.current_failure) {
              msgPath = "login_failure_limit"
            }
            this.AppState.$emit("show-message-dialog", {
              title: "LinkMeMine",
              context: { path: msgPath },
            })
          } else {
            this.$log.error(res)
          }
          return
        }

        this.AppState.Info.dateFmt = resp.dateFmt
        this.$router.push({ name: "notice" })
      })
    },
    reload() {
      window.location.reload(true)
    },
    download() {
      let a = document.createElement("a")
      const timestamp = new Date().getTime()
      
      const fileNames = {
        'Windows': "linkmeminese_windows_agent_setup.exe",
        'Android': "linkmeminese_android_agent_setup.apk",
        'Mac OS': "linkmeminese_mac_agent_setup.zip",
      }
      const fileName = fileNames[this.osType]
      
      if (fileName) {
        a.href = `${this.agent}/${fileName}?cache=${timestamp}`
        a.setAttribute('download', fileName)
      } else {
        this.$awn.warning(this.$t('not_supported_os'))
      }
      
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    appDownload() {
      let url
      if (this.isMobile === "android") {
        url = "https://play.google.com/store/apps/details?id=com.linkmemine.manager.se"
      } else {
        url = "https://apps.apple.com/sa/app/linkmeminese-manager/id6505130939"
      }
      window.open(url, "_blank")
    },
    downloadManual(type) {
      const cacheBuster = `?t=${Date.now()}`
      if (type === 'external') {
        window.location.href = `${this.AppState.Path.download}/manual/kr/원격접속_매뉴얼.pdf${cacheBuster}`;
      } else if (type === 'internal') {
        window.location.href = `${this.AppState.Path.download}/manual/kr/원격관리[설치]_매뉴얼.pdf${cacheBuster}`;
      }
    },
    showTooltipHandler(type, state) {
      if (this.showTooltips.hasOwnProperty(type)) {
        this.showTooltips[type] = state;
      }
    }
  },
  created() {
    this.osType = AppState.os
    
    if (this.isMobile !== false && this.isMobile !== "app") {
      this.showImg = true
    }
    AppState.$on("show-dialog-waiting", () => {
      this.showDialogWait = true
    })

    let params = {
      by: "notice_date",
      limit: 3,
      offset: 0,
      order: "desc",
      search_mode: "pagination",
      type: "ko",
    }
    NoticeAPI.get("", { params }).then(resp => {
      const today = new Date().getTime()
      const notices = resp.data.objects
      this.notice = notices
      if (notices.length) {
        let stored = store.get("notice_skip")
        if (stored === notices[0].pk) return
        const noticeDate = new Date(notices[0].notice_date).getTime()
        if (noticeDate > today) {
          this.noticePopup.content = notices[0]
          if (!process.env.VUE_APP_STATIC_NOTICE) {
            this.noticePopup.skipCheck = true
          }
          this.noticePopup.show = true
        }
      }
    })

    //updatePopup
    let updatePopupStored = store.get("popup_skip")
    if (updatePopupStored !== "update") {
      this.updatePopup.show = true
    }

    const rememberID = store.get("remember")
    if (rememberID) {
      this.remember = true
      this.form.id = rememberID
    } else this.remember = false

    const savedViewMode = store.get("viewMode")
    if (savedViewMode) {
      this.saveViewMode = true
      this.modeSelected = savedViewMode
    } else this.saveViewMode = false

    if (this.AppState.isMobile) {
      this.autoLoginStateHandler(this.remember)
      window.LMM_MOBILE_SEND = function() {
        if (/android/i.test(this.AppState.os)) {
          return function(m) {
            try {
              window.AndroidViewerApp.setMessage(m)
            } catch (e) {
              FB_FUNC(m)
            }
          }
        } else if (/ios/i.test(this.AppState.os)) {
          return function(m) {
            try {
              window.webkit.messageHandlers.observe.postMessage(m)
            } catch (e) {
              FB_FUNC(m)
            }
          }
        } else
          return function(m) {
            FB_FUNC(m)
          }
      }.call(this)

      window.LMM_MOBILE_CHECK = () => {
        this.AppState.isApplication = true
        store.set("LMM_MOBILE_APPLICATION", true)

        window.LMM_MOBILE_LOGIN = () => {
          this.$log.info("EXIST LOGGED IN")
          // window.LMM_MOBILE_EXIST_AUTH = false
        }

        window.LMM_MOBILE_LOGIN = (id, pw) => {
          this.form.id = id
          this.form.passwd = pw
          this.$nextTick(() => {
            this.onSubmit()
          })
        }

        window.LMM_MOBILE_LOGIN2 = (id, pw, deviceId, os, ip) => {
          this.form.id = id
          this.form.passwd = pw
          this.form.deviceId = deviceId
          this.form.os = os
          this.form.ip = ip
          this.$nextTick(() => {
            this.onSubmit()
          })
        }
      }

      window.LMM_MOBILE_CHECK2 = (deviceId, os, ip) => {
        this.AppState.isApplication = true
        store.set("LMM_MOBILE_APPLICATION", true)
        this.form.deviceId = deviceId
        this.form.os = os
        this.form.ip = ip

        window.LMM_MOBILE_LOGIN = () => {
          this.$log.info("EXIST LOGGED IN")
        }

        if (!window.LMM_MOBILE_EXIST_AUTH) {
          window.LMM_MOBILE_LOGIN = (id, pw) => {
            this.form.id = id
            this.form.passwd = pw
            this.$nextTick(() => {
              this.onSubmit()
            })
          }
        }
      }

      window.LMM_MOBILE_SEND("WEB_CHECK:LOADED:" + this.autologinReadableValue)
    }
  },
  data() {
    return {
      popupBlock: false,
      showDialogManagerApply: true,
      osType: null,
      showTooltips: {
        internal: false,
        external: false,
      },
      dialogManagerApplyData: { max: 5, current: 0 },

      showDialogAgentApply: false,
      dialogAgentApplyData: { max: 5, current: 0 },
      
      downloadButtonText: `${this.$t('first-add-device')} (${this.$t('download_remote_device')})`,

      form: {
        id: "",
        email: "",
        deviceId: "",
        os: "",
        ip: "",
        passwd: "",
      },
      loginType: 'user',
      remember: null,
      saveViewMode: null,
      showSendEmail: false,
      verifyEmail: null,
      respData: {},
      showOTP: false,
      optCode: null,
      noticePopup: {
        show: false,
        content: null,
        skip: false,
        skipCheck: false,
      },
      updatePopup: {
        show: false,
        content: null,
        skip: false,
        skipCheck: false,
      },
      modeSelected: "normal",
      notice: [],
      autologinReadableValue: "NO",
      imageData: require("@/assets/loding_img.svg"),
      showImg: false,

      showDialogWait: false,
      getNetworkType: 'public',

      agent: `${this.AppState.Path.download}/agent`,
    }
  },
}